import React, { useEffect } from 'react'
import { AddUpdateInstrument } from 'api/Trading-Accounts/Types/AddUpdateInstrument'
import { InstrumentDto } from 'api/Trading-Accounts/Types/InstrumentDto'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchTradingAccountInstrumentTypeAction } from 'store/trading-accounts/trading-accounts.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { isEmpty } from 'utils/is-empty'

import { WalletCurrencyDto } from '../../../api/Wallet/Types/WalletCurrencyDto'
import { AddEditInstrumentForm } from './AddEditInstrumentForm'

interface Props {
  isOpen?: boolean
  onClose(): void
  instrument?: InstrumentDto<string>
  currencies: WalletCurrencyDto[]

  onSubmit(values: AddUpdateInstrument<string>): Promise<void>
}

export const AddEditInstrumentPage: React.FC<Props> = (props) => {
  const { isOpen, onClose, instrument, currencies, onSubmit } = props

  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const dispatch = useAppDispatch()

  const instrumentTypes = useAppSelector(
    (state) => state.tradingAccounts.tradingAccountInstrumentType
  )
  useEffect(() => {
    if (isEmpty(instrumentTypes))
      dispatch(fetchTradingAccountInstrumentTypeAction(tradingAccountsApiClient))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AddEditInstrumentForm
      isOpen={isOpen}
      onClose={onClose}
      instrument={instrument}
      instrumentTypes={instrumentTypes}
      currencies={currencies}
      onSubmit={onSubmit}
    />
  )
}
